// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qs-0";